import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloLink, from } from 'apollo-link';
// import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
// import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';

import store from '@/store';
import { trim, compact, get } from '@/helpers';

// Install the vue plugin
Vue.use(VueApollo);

// Name of the localStorage item
const AUTH_TOKEN = 'member-token';

// const wsEndpoint =
//   `${process.env.VUE_APP_API_WS}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_ROUTE}` ||
//   'ws://localhost:4000/graphql';

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext({
        headers: {
            Authorization: localStorage.getItem('member-token')
                ? `Bearer ${localStorage.getItem('member-token')}`
                : null
        }
    });

    return forward(operation).map(response => {
        const context = operation.getContext();
        const {
            response: { headers }
        } = context;

        if (headers) {
            const token = headers.get('authorization');

            if (token) {
                const jwt = token.split('Bearer');
                if (jwt.length) {
                    const token = compact(jwt)[0].trim();
                    store.commit('auth/addTokenToState', token);
                }
            }
        }
        return response;
    });
});

const networkErrorLink = onError(parent => {
    const { networkError, graphQLErrors, operation, forward } = parent;

    if (networkError) {
        store.commit('setError', { code: networkError.statusCode, message: networkError.message });
    } else if (graphQLErrors) {
        const message = get(graphQLErrors, '0.debugMessage') || get(graphQLErrors, '0.message');
        switch (message.toLowerCase()) {
            case 'not found':
            case 'not found!':
                store.commit('setError', { code: 404, message: 'Not Found!' });
                break;
            default:
                store.commit('setError', { code: 400, message: 'Bad API request!' });
        }
    } else {
        store.commit('setError', { code: 500, message: 'An unknown error has occured!' });
    }

    return forward(operation);
});

// Config
const defaultOptions = {
    // You can use `https` for secure connection (recommended in production)
    // httpEndpoint,

    // You can use `wss` for secure connection (recommended in production)
    // Use `null` to disable subscriptions
    wsEndpoint: null,
    // LocalStorage token
    tokenName: AUTH_TOKEN,
    // Enable Automatic Query persisting with Apollo Engine
    persisting: false,
    // Use websockets for everything (no HTTP)
    // You need to pass a `wsEndpoint` for this to work
    websocketsOnly: false,
    // Is being rendered on the server?
    ssr: false

    // Override default apollo link
    // note: don't override httpLink here, specify httpLink options in the
    // httpLinkOptions property of defaultOptions.
    // link: from([authMiddleware, networkErrorLink])

    // Override default cache
    // cache: myCache

    // Override the way the Authorization header is set
    // getAuth: (tokenName) => ...

    // Additional ApolloClient options
    // apollo: { ... }

    // Client local data (see apollo-link-state)
    // clientState: { resolvers: { ... }, defaults: { ... } }
};

const publicClientOptions = {
    httpEndpoint: trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_PUBLIC_ROUTE}`,
        '/'
    ),
    link: from([authMiddleware, networkErrorLink])
};

const privateClientOptions = {
    httpEndpoint: trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_PUBLIC_ROUTE}`,
        '/'
    ),
    link: from([authMiddleware, networkErrorLink])
};

// Call this in the Vue app file
export const createProvider = (options = {}) => {
    // Create public apollo client
    const { apolloClient: publicApolloClient, wsClient: publicWsClient } = createApolloClient({
        ...defaultOptions,
        ...publicClientOptions,
        ...options
    });
    publicApolloClient.wsClient = publicWsClient;

    // Create private apollo client
    const { apolloClient: privateApolloClient, wsClient: privateWsClient } = createApolloClient({
        ...defaultOptions,
        ...privateClientOptions,
        ...options
    });
    privateApolloClient.wsClient = privateWsClient;

    // Create vue apollo provider
    const apolloProvider = new VueApollo({
        clients: {
            public: publicApolloClient,
            private: privateApolloClient
        },
        defaultClient: publicApolloClient,
        defaultOptions: {
            $query: {
                // fetchPolicy: 'cache-and-network',
            }
        },
        errorHandler(error) {
            // eslint-disable-next-line no-console
            console.log(
                '%cError',
                'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
                error.message
            );
        }
    });

    return apolloProvider;
};

const apolloProvider = createProvider();
export default apolloProvider;

// // Manually call this when user log in
// export async function onLogin(apolloClient, token) {
//   if (typeof localStorage !== 'undefined' && token) {
//     localStorage.setItem(AUTH_TOKEN, token);
//   }
//   if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
//   try {
//     await apolloClient.resetStore();
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.log('%cError on cache reset (login)', 'color: orange;', e.message);
//   }
// }
//
// // Manually call this when user log out
// export async function onLogout(apolloClient) {
//   if (typeof localStorage !== 'undefined') {
//     localStorage.removeItem(AUTH_TOKEN);
//   }
//   if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
//   try {
//     await apolloClient.resetStore();
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
//   }
// }
